module.exports = __webpack_public_path__ + "static/media/stedelijk.b08c2d6a.jpg";